import { defineStore } from 'pinia';
import { Weather } from '~/api/models/weather.model';
import { useLocationStore } from './location.store';
import { List } from '~/api/models/list.model';
import { Recommandation } from '~/api/models/recommandation.model';

export const useWeatherStore = defineStore('weather',{
    state: () => ({
        weather: null as Weather | null,
        recommandations: [] as Recommandation[],
    }),

    getters: {
        temperature(): number {
            return Math.round(this.weather?.current?.temp);
        },

        aqiTexts(): Recommandation[] {
            return this.recommandations.filter((r: Recommandation) => r.category !== 'none');
        }
    },

    actions: {
        async fetch(): Promise<Weather> {
            const locationStore = useLocationStore();

            if(!locationStore.location) {
                await locationStore.fetchLocation();
            }

            return this.$weatherService.getWeather(locationStore.location);
        },

        async fetchRecommandation(locale: string = 'en'): Promise<Recommandation[]> {
            return this.$weatherService.getRecommandations(locale)
                .then((list: List<Recommandation>) => list.data)
                .then( (recommandations: Recommandation[]) => this.recommandations = recommandations);
        }
    }
});